import { render, staticRenderFns } from "./productitemunits.vue?vue&type=template&id=601b714e&scoped=true&"
import script from "./productitemunits.vue?vue&type=script&lang=js&"
export * from "./productitemunits.vue?vue&type=script&lang=js&"
import style0 from "./productitemunits.vue?vue&type=style&index=0&id=601b714e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601b714e",
  null
  
)

export default component.exports